export const iconFontAwesomeTravelHotelTruckMedical = (
	<i className="fa-solid fa-truck-medical"></i>
);
